import { PropsWithChildren } from "react";
import { useToolEffectSelectionNavigation } from "./effectHooks/useToolEffectSelectionNavigation";
import { useToolEffectMeasureProjectSync } from "./effectHooks/useToolEffectMeasureProjectSync";
import { useToolEffectElementRepositionProjectSync } from "./effectHooks/useToolEffectElementRepositionProjectSync";

export function ToolEffectHooksProvider(p: PropsWithChildren) {
  useToolEffectSelectionNavigation();
  useToolEffectMeasureProjectSync();
  useToolEffectElementRepositionProjectSync();

  return <>{p.children}</>;
}
